import { COMPANY_API, COMPANY_API_NO_RESULT_RESPONSE } from 'apis';

const PREFIX = '/captain-payment/member';

// 서비스별 메뉴 권한 목록 (menuAuthIdx ↔ 권한명 매핑표)
export const getMemberAuth = async () => {
  const result = await COMPANY_API.get(`${PREFIX}/v1/auth`);
  return result.data;
};

export const getWelfare = async () => {
  const result = await COMPANY_API.get(`${PREFIX}/v1/welfare`);
  return result.data;
};

export const getNotice = async (params) => {
  const result = await COMPANY_API.get(`${PREFIX}/v1/notice`, { params });
  return result;
};

export const saveNotice = async (data) => {
  const result = await COMPANY_API.post(`${PREFIX}/v1/notice`, data);
  return result.data;
};

export const getNoticeByKey = async (id, params) => {
  const result = await COMPANY_API.get(`${PREFIX}/v1/notice/${id}`, { params });
  return result;
};

export const updateNotice = async (id, data) => {
  const result = await COMPANY_API.put(`${PREFIX}/v1/notice/${id}`, data);
  return result.data;
};

export const getPushMessage = async (params) => {
  const result = await COMPANY_API.get(`${PREFIX}/v1/push`, { params });
  return result.data;
};

export const sendPushMessage = async (data) => {
  const result = await COMPANY_API.post(`${PREFIX}/v1/push`, data);
  return result.data;
};

export const getWelfareList = async () => {
  const result = await COMPANY_API.get(`${PREFIX}/v1/welfare`);
  return result.data;
};

export const getWelfarePolicyList = async (idx) => {
  const result = await COMPANY_API.get(`${PREFIX}/v1/welfare/${idx}/policy`);
  return result.data;
};

export const putWelfarePolicy = async (idx, params) => {
  const result = await COMPANY_API.put(`${PREFIX}/v1/welfare/${idx}/policy`, params);
  return result.data;
};

export const getPolicyHistoryWel = async (params) => {
  const result = await COMPANY_API.get(`${PREFIX}/v1/welfare/history/policy`, { params });
  return result.data;
};

export const userExcelCheck = async (params) => {
  const result = await COMPANY_API_NO_RESULT_RESPONSE.post(`${PREFIX}/v1/employee/upload/check`, params, {
    headers: { 'content-type': 'multipart/form-data' }
  });
  return result.data;
};

export const userExcelUpload = async (params) => {
  const result = await COMPANY_API.post(`${PREFIX}/v1/employee/upload`, params, {
    headers: { 'content-type': 'multipart/form-data' }
  });
  return result.data;
};
